import axios from 'axios';
import { useEffect, useReducer } from 'react';
import { systemCode, xs_languageCode } from '..';
import { dataFetchReducer, getLocalizedScoreLabel } from './data';
import { getConfiguration, parseHandicap, getAmountInCent, getAggregationAndBetFromBetIdAndSportId, getBetDescription, truncateDoubleTo, convertToDecimalWithPrecision } from './utils';

function parseBets(isTicketLive, sportId, bets, descAvv, isPsv) {
    return bets.map(bet => {
    	const conf = getConfiguration();
    	let desc = bet.rds;
    	let drawDesc = bet.rdd;
        if (!isPsv) {
        	desc = getBetDescription(bet, false, sportId); // potremmo fermarci qui?
        	if (bet.bonus) {
            	desc = "* " + desc;
            }
            
            
            let containerAggMarket = getAggregationAndBetFromBetIdAndSportId(sportId, bet.cs, bet.h);
			if(!containerAggMarket.market && bet.h !== 0){
				containerAggMarket = getAggregationAndBetFromBetIdAndSportId(sportId,bet.cs, 0);
			}
			const betFromAgg = containerAggMarket?.market;
			if(betFromAgg){
				/*if (betFromAgg.parametrica || betFromAgg.calculateHandicapDescription) {
	                let hcp = bet.h;
	                let handleAsianHandicap = false;
	                if (isAsianHandicap(bet.cs) && bet.cep === 2) {
	                    if (betFromAgg.tipoHandicap !== 23) {
	                        hcp *= -1;
	                    }
	                    handleAsianHandicap = true;
	                }
	                let dia = bet.dia;
	                if (dia.includes('#')) {
	                    const parts = dia.split('#');
	                    dia = parts[1];
	                }
	                desc = parseHandicap(desc, hcp, betFromAgg.tipoHandicap, null, dia, handleAsianHandicap);
	            }	*/	
	            if(betFromAgg.hideHandicap){
	            	for (let ko in betFromAgg.odds) {
	                    if (betFromAgg.odds[ko].id === bet.cep) {  
	                    	const drawFromAgg = betFromAgg.odds[ko];       
	                    	drawDesc = drawFromAgg.desc.length > 0? drawFromAgg.desc : drawDesc;
	                    }
	                }
	            	drawDesc = `${drawDesc} ${betFromAgg.desc}`;
	            }
	            else {
	               for (let ko in betFromAgg.odds) {
	                    if (betFromAgg.odds[ko].id === bet.cep) {                            
							const drawFromAgg = betFromAgg.odds[ko];
							drawDesc = drawFromAgg.desc;
							if (drawFromAgg.tooltip && drawFromAgg.tooltip != '' && conf.tod) {
								const teams = descAvv.split(' - ');
								if (teams && teams.length > 1) {
									drawDesc = drawFromAgg.tooltip;
									drawDesc = drawDesc.replaceAll('{{TEAM1}}', teams[0]);
									drawDesc = drawDesc.replaceAll('{{TEAM2}}', teams[1]);
	    							drawDesc = parseHandicap(drawDesc, bet.h, betFromAgg.tipoHandicap, null, bet.dia, false);
								}
							}
	                        break;
	                    }  
	                }	            
	            }	
 
			}

        }

        return {
            id: bet.cs,
            handicap: bet.h,
            drawCode: bet.cep,
            desc,
            rawDesc: bet.rds,
            drawDesc,
            rawDrawDesc: bet.rdd,
            winningDrawCode: bet.cew,
            odd: bet.odd,
            isWinning: bet.win,
        };
    });
}

function parseEvents(isTicketLive, events, ticketRef, isPsv) {
    return events.map(event => {
        let desc = event.dst;
        if (desc?.length > 0) {
            const parts = desc.split(' - ');
            if (parts.length === 3) {
                desc = `${parts[1]} | ${parts[2]}`;
            }
        } else {
            desc = desc.replace(' - ', ' | ');
        }
		let partialScores = [];
		if(event.prs){
			for(let ks in event.prs){
				const values = event.prs[ks].split('#');
				if(values.length == 2){
					const label = getLocalizedScoreLabel(1, values[0]);
					partialScores.push(label + "#" + values[1]);
				}
				else{
					partialScores.push(event.prs[ks]);
				}
			}
		}
        return {
            ticketRef,
            alias: event.al,
            pal: event.p,
            avv: event.a,
            id: event.mid,
            desc: event.ds,
            tournamentDesc: desc,
            sportRef: event.is,
            categoryRef: event.ic,
            tournamentRef: event.it,
            categoryIcon: event.catIc,
            sportIcon: event.spIc,
            timing: event.tim,
            score: event.res,
            partialScores,
            var: event.var,
            state: event.st,
            timestamp: event.ts,
            bets: parseBets(isTicketLive, event.is, event.scs, event.ds, isPsv),
            widgetType: event.wty,
            geniusId: event.gid,
            lsportWidgetId: event.lswid
        };
    }).sort((a, b) => a.timestamp.localeCompare(b.timestamp));
}

function parseTuples(tuples) {
    return tuples.map(tuple => {
        return {
            amount: tuple.amn,
            combinations: tuple.comb,
            desc: tuple.ds,
            maxWinnings: tuple.max,
            minWinnings: tuple.min,
            npla: tuple.npla,
        };
    });
}

function parseTicketData(data) {
    return {
        id: data.id,
        type: data.ty,
        status: data.st,
        internalStatus: data.inSt,
        live: data.liv,
        timestamp: data.tsp,
        nickname: data.nic,
        amount: data.amn,
        potentialWinnings: data.pwn,
        winnings: data.ewn,
        bonusAmount: data.bon,
        funBonus: data.fnb,
        freeBet : data.frb,
        events: parseEvents(data.lv, data.evs, data.id, data.psv),
        tuples: data.tups ? parseTuples(data.tups) : null,
        totalEventsNumber: 0,
        openedEventsNumber: 0,
        totalOdds : getTotalOdds(data),
        psv : data.psv,
        paidWithCashout : data.pch,
        betBuilderTotalOdd : data.bbo,
        isBetBuilder : data.bbo > 0,
        payable : data.payb,
        cancelAvailable : data.ann,
        cashoutData : data.cshd,
        reprintReceipt : data.rcrp
    };
}

function getTotalOdds(data) {
	try {
		if (data.ty === 'systembets') {
			return 0;
		}
		if (data.ty === 'singlebets') {
			return data.evs[0].scs[0].odd;
		}
		let totalOdd = 1;
		for (let k in data.evs) {
			let selection = data.evs[k];
			for(let kb in selection.scs){
				let bet = selection.scs[kb];
				totalOdd = totalOdd * convertToDecimalWithPrecision(bet.odd, 19, 6)/100;
				totalOdd = convertToDecimalWithPrecision(totalOdd, 19, 6);
			}

		}
		totalOdd = truncateDoubleTo(totalOdd, 2);
		return getAmountInCent(totalOdd, 100);
	}
	catch(e) {
        console.error(e);
    }
	
	return 0;
}

export function useFetchCheckbetTicket(id, shouldExecute, pollingEnabled, skipExecution) {
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });
    
    useEffect(() => {
        let intervalId = null;
        if (!shouldExecute) {
            clearInterval(intervalId);
            return;
        }
        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };

        const conf = getConfiguration();
        const url = conf['api']['getCheckbetTicket'];
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            idTicket: id
        };
        if (!skipExecution) {
            fetchData(url, params, function(response) {
                const data = !response?null:parseTicketData(response);
                dispatch({ type: 'FETCH_SUCCESS', payload: data });
            });
        }
       

        let intervalMillis = null;
        try {
            intervalMillis = conf.ctp;
        } catch(e) {
            intervalMillis = 10000;
        }
        if (intervalMillis > 0) {
            if (pollingEnabled) {
                clearInterval(intervalId);
                intervalId = setInterval(() => {
                    fetchData(url, params, function(response) {
                        const data = parseTicketData(response);
                        dispatch({ type: 'FETCH_SUCCESS', payload: data });
                    });
                }, intervalMillis);
            } else if (intervalId != null) {
                clearInterval(intervalId);
            }
        }

        return () => {
            didCancel = true;
            clearInterval(intervalId);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, shouldExecute, pollingEnabled]);

    return [state, dispatch];
}
